import React, { useEffect } from "react";
import AppUtils from "@src/utils/appUtils";
import PropTypes from "prop-types";
import { useOperatorContext } from "@src/context/operatorContext";
import DropDown from "./DropDown.jsx";
import { useManagerContext } from "@src/context/managerContext";
import { trackActionActivity } from "@src/utils/userActivityTracker";

const BehaviourDropDown = ({
  behaviours,
  selectedBehaviour,
  setSelectedBehaviour,
  shortLabel = false,
  minWidth = false,
  fullWidth,
  className = "",
}) => {
  const formattedBehaviours = [...behaviours]
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
    .map((b) => {
      return {
        ...b,
        value: b.behaviourAcronym,
        text: !shortLabel ? b.behaviourName : b.behaviourAcronym,
      };
    });
  useEffect(() => {
    if (!selectedBehaviour) {
      setSelectedBehaviour(formattedBehaviours[0]);
    }
  }, [formattedBehaviours, selectedBehaviour, setSelectedBehaviour]);

  const defaultBehaviour = selectedBehaviour || formattedBehaviours[0];

  const handleDropdownChange = (e) => {
    const newBvr = formattedBehaviours.find((p) => p.value === e);
    trackActionActivity("BEHAVIOUR_DROPDOWN_SELECTION", {
      behaviourAcronym: newBvr.behaviourAcronym,
    });
    setSelectedBehaviour(newBvr);
  };

  return formattedBehaviours ? (
    <DropDown
      fullWidth={fullWidth}
      minWidth={minWidth}
      options={formattedBehaviours}
      value={defaultBehaviour.behaviourAcronym}
      onChange={handleDropdownChange}
      className={className}
    />
  ) : null;
};

export const BehaviourDropDownOperator = ({
  behaviours = null,
  shortLabel = false,
  fullWidth = true,
  minWidth = false,
}) => {
  const { profile, selectedBehaviour, setSelectedBehaviour } =
    useOperatorContext();

  behaviours = behaviours != null ? behaviours : profile.behaviours;

  return behaviours?.length > 0 ? (
    <BehaviourDropDown
      behaviours={behaviours}
      selectedBehaviour={selectedBehaviour}
      setSelectedBehaviour={setSelectedBehaviour}
      shortLabel={shortLabel}
      minWidth={minWidth}
      fullWidth={fullWidth}
    />
  ) : null;
};

export const BehaviourDropDownManager = ({
  behaviours = null,
  shortLabel = false,
  minWidth = false,
}) => {
  const { profile, selectedBehaviour, setSelectedBehaviour } =
    useManagerContext();

  behaviours = behaviours != null ? behaviours : profile.behaviours;

  return behaviours?.length > 0 ? (
    <BehaviourDropDown
      behaviours={behaviours}
      selectedBehaviour={selectedBehaviour}
      setSelectedBehaviour={setSelectedBehaviour}
      shortLabel={shortLabel}
      minWidth={minWidth}
      fullWidth={false}
      className="w-full lg:w-96 px-2 md:px-4"
    />
  ) : null;
};

export const BehaviourDropDownControls = {};

BehaviourDropDown.propTypes = AppUtils.getPropTypeFromControls(
  BehaviourDropDownControls,
);

export default BehaviourDropDown;
